/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { jwtDecode } from 'jwt-decode';
import { API_URL_CONSTANT } from '@sharedModule/constants/api-url.constant';
// import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { isNonArrayObject } from '@sharedModule/utils/type-guard.util';
import { HttpClientService } from '../http-client/http-client.service';
import { LocalStorageService } from '../local-storage/local-storage.service';
import {
  LoginInterface,
  LoginResponseInterface,
  MobileLoginInterface,
  MobileLoginResponseInterface,
  MobileOtpVerifyPayloadInterface,
  OtpVerficationResponseInterface,
  UserPermissionDetailsInterface,
  UserPermissionsInterface,
} from '@core/models/authentication.model';
import { HttpClient } from '@angular/common/http';
import { LOGIN_INTERFACE } from '@feature/auth/types/login-interface';
import { ResponseIdentity } from '@sharedModule/models/server-response-identity.model';
import { HeaderService } from '../header/header.service';
import {
  Permission,
  USER_DETAILS_INTERFACE,
  
} from '@core/layout/header/userDetails-interface';
import {
  VerficationResponse_I,
  VerificationPayload_I,
} from '@feature/auth/types/verification-interfaces';
import { RESENDOTP_I } from '@feature/auth/types/resendOtp-interface';
import { ClientNameService } from '@sharedModule/services/clientName/client-name.service';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  constructor(
    private router: Router,
    private httpClient: HttpClientService,
    private localStorageService: LocalStorageService,
    private headerService: HeaderService,
    private clientNameService:ClientNameService
  ) {}

  mobilePinId = signal<string>('');
  mobileOtpVerifyPayload = signal<MobileOtpVerifyPayloadInterface>({
    otp: '',
    phone: +'',
    pinId: '',
    dialCode: '',
  });
  loginSignal = signal<Partial<LOGIN_INTERFACE> | null>(null);
  resendOtp = signal<LoginInterface | null>(null);
  private isCredentialVerified = false;

  checkLogin(): boolean {
    const access_token = this.getToken();
    return !!access_token && !this.isTokenExpired(access_token);
  }

  isTokenExpired(accessTokenValue: string): boolean {
    const tokenExpiryDate = this.getTokenExpiryDate(accessTokenValue);
    const currentDate = new Date();
    return !tokenExpiryDate || currentDate >= tokenExpiryDate;
  }

  getTokenExpiryDate(accessTokenValue: string): Date | null {
    const tokenInfo = this.decodeToken(accessTokenValue);
    if (!this.hasExp(tokenInfo)) {
      return null;
    }
    const expirationDate = new Date(0);
    expirationDate.setUTCSeconds(tokenInfo.exp);
    return expirationDate;
  }

  hasExp(tokenInfo: unknown): tokenInfo is { exp: number } {
    return isNonArrayObject(tokenInfo) && 'exp' in tokenInfo;
  }

  decodeToken(accessTokenValue: string): unknown | null {
    const tokenInfo = jwtDecode<{ exp: number }>(accessTokenValue);
    if (!tokenInfo || !tokenInfo.exp) {
      this.initializeLogout();
      return null;
    }
    return tokenInfo;
  }

  login(
    payload: LoginInterface
  ): Observable<ResponseIdentity<LOGIN_INTERFACE>> {
    this.resendOtp.set(payload);
    return this.httpClient.post(API_URL_CONSTANT.authentication.logIn, payload);
  }

  mobileLogin(
    payload: MobileLoginInterface
  ): Observable<MobileLoginResponseInterface> {
    return this.httpClient.post(
      API_URL_CONSTANT.authentication.mobileLogin,
      payload
    );
  }

  otpVerification(
    code: string
  ): Observable<ResponseIdentity<VerficationResponse_I>> {
    const payload: Partial<VerificationPayload_I> = {
      ...this.loginSignal(),
      verificationCode: code,
    };
    return this.httpClient.post(
      API_URL_CONSTANT.authentication.otpVerification,
      payload
    );
  }

  signupForm(formData: FormData): Observable<any> {
    return this.httpClient.post(
      API_URL_CONSTANT.authentication.register,
      formData
    );
  }

  verifySignupEmail(data: string): Observable<any> {
    return this.httpClient.post(
      API_URL_CONSTANT.authentication.verifyEmail,
      data
    );
  }

  getToken(): string | null {
    return this.localStorageService.get('access_token') ?? null;
  }

  initializeLogout(): void {
  this.setCredentialVerified(false);
    this.clientNameService.clientName.set(null);
    this.localStorageService.clear();
    this.router.navigate(['/auth/login']);
  }

  // Perimision list-----------------------------
  private userPermissions!: Permission[];

  getUserPermission(): Permission[] {
    return this.userPermissions;
  }

  public getUserPermissions(): Observable<
    ResponseIdentity<USER_DETAILS_INTERFACE>
  > {
    return this.httpClient.get(API_URL_CONSTANT.user.getDetails);
  }

  setUserPermission(data: Permission[]): void {
    this.userPermissions = data;
  }

  getResendOtp(): Observable<ResponseIdentity<RESENDOTP_I>> {
    const payload: Partial<VerificationPayload_I> = {};
    return this.httpClient.post(API_URL_CONSTANT.authentication.resendOtp, {
      ...this.resendOtp(),
    });
  }


  setCredentialVerified(status: boolean) {
    this.isCredentialVerified = status;
  }

  getCredentialVerified(): boolean {
    return this.isCredentialVerified;
  }


}
